"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTextarea", {
  enumerable: true,
  get: function get() {
    return _SVBTextarea.default;
  }
});
var _SVBTextarea = _interopRequireDefault(require("./src/SVBTextarea"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }